// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"1563f01f","113":"4187d9ff","271":"1563f01f","769":"4187d9ff"}[chunkId] + ".chunk.css";
};